import React, {useMemo} from "react";
import {useHtmlClassService} from "../../_core/MetronicLayout";
import { BASE_URL } from "../../../../env_config"

export function Footer() {
  const today = new Date().getFullYear();
  const uiService = useHtmlClassService();

  const layoutProps = useMemo(() => {
    return {
      footerClasses: uiService.getClasses("footer", true),
      footerContainerClasses: uiService.getClasses("footer_container", true)
    };
  }, [uiService]);

  return (
    <div
      className={`footer bg-white py-4 d-flex flex-lg-column  ${layoutProps.footerClasses}`}
      id="kt_footer"
    >
      <div
        className={`${layoutProps.footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
      >
        <div className="text-dark order-2 order-md-1">
          <span className="text-muted font-weight-bold mr-2">{today.toString()}</span> &copy;{" "}
          <a
            href={BASE_URL}
            target="_blank"
            rel="noopener noreferrer"
            className="text-dark-75 text-hover-primary"
          >
            Diamondsoncall
          </a>
        </div>
        <div className="nav nav-dark order-1 order-md-2">
          {/* <a
            href={`${BASE_URL}/faq`}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link pr-3 pl-0"
          >
            FAQs
          </a>
          <a
            href={`${BASE_URL}/term-condition`}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link px-3"
          >
            Terms and Conditions
          </a>
          <a
            href={`${BASE_URL}/privacy-policy`}
            target="_blank"
            rel="noopener noreferrer"
            className="nav-link pl-3 pr-0"
          >
           Privacy Policy
          </a> */}
        </div>
      </div>
    </div>
  );
}
